import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { BillReportDashboard } from 'portal/src/components/reports/BillReportDashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from './routeGenerator';

export const reportRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.ACCOUNT_DETAILS} />
    ),
    name: 'Account Details',
    path: NESTED_ROUTES.REPORTS.ACCOUNT_DETAILS,
    description: 'Account and line-item details',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.CALENDAR_NORMALIZED} />
    ),
    name: 'Calendar Normalized',
    path: NESTED_ROUTES.REPORTS.CALENDAR_NORMALIZED,
    description: 'Calendar normalized data by facility',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.FACILITIES} />,
    name: 'Facilities',
    path: NESTED_ROUTES.REPORTS.FACILITIES,
    description: 'Facility details',
  },
  {
    element: <BillReportDashboard />,
    name: 'Bills',
    path: NESTED_ROUTES.REPORTS.BILLS,
    description: 'Bill details',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.REPORTS.HISTORICAL_USAGE_COST}
      />
    ),
    name: 'Historical Usage and Cost',
    path: NESTED_ROUTES.REPORTS.HISTORICAL_USAGE_COST,
    description: 'Analyze total historical usage and cost together by month',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.TOTAL_ENERGY_COSTS} />
    ),
    name: 'Total Energy Costs',
    path: NESTED_ROUTES.REPORTS.TOTAL_ENERGY_COSTS,
    description: 'View total energy costs and changes by fiscal year',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.REPORTS.LINE_ITEMS} />,
    name: 'Line Items',
    path: NESTED_ROUTES.REPORTS.LINE_ITEMS,
    description: 'Analyze and group bill data at the line-item level',
  },
];
